import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import * as _ from 'lodash';
import { ProcessService } from 'src/app/modules/instance/services/process.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    standalone: false,
    selector: 'app-remove-selected-processes',
    templateUrl: './remove-selected-processes.component.html',
    styleUrls: ['./remove-selected-processes.component.scss']
})
export class RemoveSelectedProcessesComponent implements OnInit {
    @Input()
    processesList: ITaskModel[];

    get processesToRemove(): ITaskModel[] {
        return _.defaultTo(this.processesList, [])
            .filter(process => process.isSelected);
    }

    get isActive(): boolean {
        return !_.isEmpty(this.processesToRemove);
    }

    constructor(
        private readonly dialog: MatDialog,
        private readonly processService: ProcessService
    ) { }

    ngOnInit(): void { }

    async removeSelectedProcesses() {
        if (!this.isActive) {
            return;
        }

        const removeCount = this.processesToRemove.length;

        const deleteDialogConfig = new MatDialogConfig();
        deleteDialogConfig.autoFocus = true;
        deleteDialogConfig.data = {
            title: 'Delete Jobs',
            topContent: `You are going to remove ${removeCount} Job${removeCount > 1 ? 's' : ''}. This operation can't be undone.
      Continue?`
        };

        const recalculateDialogRef = this.dialog
            .open(ConfirmationDialogComponent, deleteDialogConfig);

        recalculateDialogRef.afterClosed()
            .subscribe(confirmed => {
                if (!confirmed) {
                    return;
                }
                const states = _.uniq(
                    this.processesToRemove
                        .map(process => process.state)
                        .filter(state => !!state)
                );

                states.forEach(state => {
                    const processesIds = this.processesToRemove
                        .filter(process => process.state === state)
                        .map(process => process.id);
                    this
                        .processService
                        .removeProcesses(
                            state,
                            processesIds
                        )
                        .subscribe();
                });
            });
    }
}
